import {createFeatureSelector, createSelector} from "@ngrx/store";
import {ISharedSolutionStoreState} from "./shared-solution.state";

export const sharedSolutionSelect = createFeatureSelector<ISharedSolutionStoreState>('sharedSolution');

export const selectIsLoading = createSelector(
  sharedSolutionSelect,
  (state: ISharedSolutionStoreState) => state.isLoading
);

export const selectMissionId = createSelector(
  sharedSolutionSelect,
  (state: ISharedSolutionStoreState) => state.currentMissionId
);

export const selectNoteTopic = createSelector(
  sharedSolutionSelect,
  (state: ISharedSolutionStoreState) => state.currentNoteTopic
);

export const selectSolutionList = createSelector(
  sharedSolutionSelect,
  (state: ISharedSolutionStoreState) => state.currentSolutionList
);
